// document.addEventListener('click', function(e) {
//   const popup = document.getElementById('halo-product-custom-information');

//   // Đóng popup
//   if (e.target.closest('[data-close-custom-information]')) {
//     const iframe = popup.querySelector('iframe');
//     if (iframe) iframe.remove();
//     popup.classList.remove('is-show');
//     return;
//   }

//   // Mở popup
//   const btn = e.target.closest('[data-open-custom-information]');
//   if (btn) {
//     const content = popup.querySelector('.halo-popup-content');

//     // Xóa iframe cũ
//     const oldIframe = content.querySelector('iframe');
//     if (oldIframe) oldIframe.remove();

//     // Tạo iframe mới
//     const iframe = document.createElement('iframe');
//     iframe.width = '660';
//     iframe.height = '373';
//     iframe.frameBorder = '0';
//     iframe.allow = 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
//     iframe.referrerPolicy = 'strict-origin-when-cross-origin';
//     iframe.allowFullscreen = true;

//     // Lấy src dynamic từ nút mở popup
//     const videoSrc = btn.getAttribute('data-video-src');
//     iframe.src = videoSrc;

//     content.appendChild(iframe);
//     popup.classList.add('is-show');
//   }
// });

document.addEventListener('click', function(e) {
  const popup = document.getElementById('halo-product-custom-information');

  if (e.target.closest('[data-close-custom-information]')) {
    const iframe = popup.querySelector('iframe');
    if (iframe) iframe.remove();
    popup.classList.remove('is-show');
    return;
  }

  const btn = e.target.closest('[data-open-custom-information]');
  if (btn) {
    const content = popup.querySelector('.halo-popup-content');

    const oldIframe = content.querySelector('iframe');
    if (oldIframe) oldIframe.remove();

    const iframe = document.createElement('iframe');
    iframe.width = '660';
    iframe.height = '373';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    // Gán src khi mở popup
    iframe.src = btn.getAttribute('data-video-src');

    content.appendChild(iframe);
    popup.classList.add('is-show');
  }
});


